import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type CourseMembershipAttrs = {
  id: number
  courseId: number
  studentId: number
}

const toCamel = ({
  id,
  'student-id': studentId,
  'course-id': courseId
}: FancyOk<fancyOperations['getCourseMembershipsR']>[0]): CourseMembershipAttrs => ({
  id,
  studentId,
  courseId
})

export const fetchCourseMemberships = (): Promise<Array<CourseMembershipAttrs>> =>
  fancyClient
    .GET('/2/course-memberships')
    .then(extractData)
    .then(data => data.map(toCamel))
